export default "__VITE_ASSET__8730a1af__"